import { render, staticRenderFns } from "./responsaveis.vue?vue&type=template&id=5e96eac5&scoped=true&"
import script from "./responsaveis.vue?vue&type=script&lang=js&"
export * from "./responsaveis.vue?vue&type=script&lang=js&"
import style0 from "./responsaveis.vue?vue&type=style&index=0&id=5e96eac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96eac5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
